export class RentalStatisticRequest {
  userId?: number;
  fromDate?: number;
  toDate?: number;
  statisticType?: string;
  multipleUser?: number[];
}
